(function() {
  'use strict';

  // Apply AngularJS's $locale formats (month/day names, date & number formats)
  // from the data Angular derived for the locale it was compiled with. The data
  // is built in the Angular layer (see ang2/app/locale-bridge.ts) from Angular's
  // own registered locale data and handed across on window.kzAngularLocaleData,
  // so legacy date/number filters match the Angular app for every locale
  // (fr-CA, en-AU, en-CA, en-GB, ...) without any hand-maintained tables.
  function run($locale) {
    var data = window.kzAngularLocaleData;
    if (!data) {
      // No Angular-derived data available (e.g. legacy loaded standalone or in
      // tests); keep AngularJS's built-in default $locale.
      return;
    }

    if (data.DATETIME_FORMATS) {
      angular.extend($locale.DATETIME_FORMATS, data.DATETIME_FORMATS);
    }
    if (data.NUMBER_FORMATS) {
      angular.extend($locale.NUMBER_FORMATS, data.NUMBER_FORMATS);
    }
    if (data.id) {
      $locale.id = data.id;
    }
    if (data.localeID) {
      $locale.localeID = data.localeID;
    }
    if (typeof data.pluralCat === 'function') {
      $locale.pluralCat = data.pluralCat;
    }
  }

  run.$inject = ['$locale'];

  angular
    .module('epf.core')
    .run(run);
})();
